var BUTTON_WIDTH = 16;
var BUTTON_OFFSET = 8;

/**
 * Вычисляет общее расстояние прокрутки скролла для показа крайнего элемента
 */
export function getTotalScrollDistance(scrollDistance, direction) {
  var result = scrollDistance + BUTTON_WIDTH + BUTTON_OFFSET;
  return direction === 'left' ? -result : result;
}